import * as React from 'react';
import { connect } from 'react-redux';
import { EMPTY_TEXT, getRandomUuidV4 } from "../../common";
import { FileUploadStatus, FileValidationService } from "../../file";
import { getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { photoCaptureFileUploadFailedAction, photoCaptureIntelligentSaveCapturedPhotoAction, photoCaptureIntelligentUpdateOCRInfo, photoCaptureIntelligentViewChangeAction, photoCaptureInvalidFileUploadAction, photoCaptureIsFileUploadStartedAction } from '../actions';
import { IntelligentPhotoCaptureCameraView } from '../components/intelligentComponents';
import { PhotoCaptureConstants } from '../constants';
import { IntelligentPhotoCaptureViewType, PhotoCaptureAttributeType } from '../enums';
import { getIntelligentSequenceScreenName, getPhotoCaptureCompanyCode, getPhotoCaptureDisableLibrary, getPhotoCaptureFileSizeLimit, getPhotoCaptureImageMaxWidth, getShouldAllowMitchellIntelligent, getShouldEnableOCRImageTextDecode, getCapturedUploadPhotoFiles, getIntelligentPhotoCapturePRGMiscDetails, getShouldAllowVinDecode } from '../selectors';
import { getFileDescriptionByAttributeType, photoCaptureIntelligentUploadCapturedPhoto } from '../utilities';
import { DeviceUtilitiesService } from '@mitchell/react.component.ux';
const mapStateToProps = (state) => {
    return {
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        sequenceScreenName: getIntelligentSequenceScreenName(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        maxFileSize: getPhotoCaptureFileSizeLimit(state),
        applicationName: PhotoCaptureConstants.PHOTO_CAPTURE_APPLICATION_NAME,
        shouldAllowMitchellIntelligent: getShouldAllowMitchellIntelligent(state),
        shouldEnableOCRImageTextDecode: getShouldEnableOCRImageTextDecode(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        imageMaxWidth: getPhotoCaptureImageMaxWidth(state),
        files: getCapturedUploadPhotoFiles(state),
        prgMiscImage: getIntelligentPhotoCapturePRGMiscDetails(state),
        shouldAllowVinDecode: getShouldAllowVinDecode(state)
    };
};
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    },
    onSaveCapturedPhoto: (files, uiGuidanceScores, questionSubType, sequenceScreenName, companyCode, maxFileSize, imageMaxWidth, shouldAllowMitchellIntelligent, updatePageAttachmentHistory, shouldAllowVinDecode, isPrgParentImage, isMobile) => {
        const fileMetadataDesc = getFileDescriptionByAttributeType(questionSubType, isPrgParentImage, sequenceScreenName);
        const ocrInfo = {
            ocrText: EMPTY_TEXT,
            errorMessage: EMPTY_TEXT,
            isOCRServiceCallCompleted: false
        };
        dispatch(photoCaptureIntelligentUpdateOCRInfo(ocrInfo));
        const onFileUploadSuccess = (responseFile) => {
            if (shouldAllowMitchellIntelligent && responseFile && responseFile[0] && responseFile[0].docUID) {
                const docUID = responseFile[0].docUID;
                let uiScores;
                if (!!files.isCameraCapturedImage) {
                    uiScores = {
                        uiBrightnessScore: uiGuidanceScores.brightness,
                        uiContrastScore: uiGuidanceScores.contrast,
                        uiGammaScore: uiGuidanceScores.gamma,
                        uiBlurScore: uiGuidanceScores.blur
                    };
                }
                updatePageAttachmentHistory(docUID, uiScores, true);
                if (questionSubType === PhotoCaptureAttributeType.VIN_CAPTURE && shouldAllowVinDecode) {
                    dispatch(photoCaptureIntelligentViewChangeAction(IntelligentPhotoCaptureViewType.VIN_DECODE, sequenceScreenName));
                }
                else {
                    dispatch(photoCaptureIntelligentViewChangeAction(IntelligentPhotoCaptureViewType.PREVIEW, sequenceScreenName));
                }
            }
        };
        photoCaptureIntelligentUploadCapturedPhoto(files, companyCode, maxFileSize, fileMetadataDesc, imageMaxWidth, dispatch, onFileUploadSuccess, isMobile);
        dispatch(photoCaptureIntelligentSaveCapturedPhotoAction(files));
    },
    getIsInvalidFile: ({ file, maxFileSize, allowedFileTypes }) => {
        const fileUploadError = FileValidationService.validateFile({
            maxFileSize,
            file,
            allowedFileTypes
        });
        if (fileUploadError) {
            dispatch(photoCaptureInvalidFileUploadAction({
                uploadError: fileUploadError,
                fileName: file.name,
                fileId: getRandomUuidV4(),
                uploadStatus: FileUploadStatus.FAILED
            }));
        }
        return !!fileUploadError;
    },
    onFileUploadFailed: () => {
        dispatch(photoCaptureFileUploadFailedAction());
        dispatch(photoCaptureIsFileUploadStartedAction(false));
    }
});
const IntelligentPhotoCaptureCameraViewWrapper = (props) => {
    const deviceUtilities = new DeviceUtilitiesService();
    const isMobileView = deviceUtilities.isMobile();
    return (React.createElement(IntelligentPhotoCaptureCameraView, Object.assign({}, props, { onSaveCapturedPhoto: (files, uiGuidanceScores) => props.onSaveCapturedPhoto(files, uiGuidanceScores, props.questionSubType, props.sequenceScreenName, props.companyCode, props.maxFileSize, props.imageMaxWidth, props.shouldAllowMitchellIntelligent, props.updatePageAttachmentHistory, props.shouldAllowVinDecode, props.prgMiscImage && props.prgMiscImage.isParentImage, isMobileView) })));
};
export const ConnectedIntelligentPhotoCaptureCameraView = connect(mapStateToProps, mapDispatchToProps)(IntelligentPhotoCaptureCameraViewWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureCameraView.js.map